export default {
  title: 'Статистика шаблонов',
  searchPlaceholder: 'Быстрый поиск по названию или ID шаблона',
  total: 'Шаблонов',
  filters: {
    channel: 'Канал',
    category: 'Категория шаблона',
    status: 'Статус шаблона',
  },
  th: {
    id: 'ID шаблона',
    name: 'Название шаблона',
    status: 'Статус',
    channel: 'Канал',
    category: 'Категория',
    read: 'Прочитано сообщений по шаблону',
  },
  info: {
    status: 'Статус:',
    channel: 'Канал:',
    registerDate: 'Шаблон зарегистрирован:',
    operators: 'Статус шаблона у операторов:',
    category: 'Категория шаблона:',
    toTemplate: 'В карточку шаблона',
  },
  results: 'Результаты шаблона',
  resultsHint:
    'В некоторых случаях статистика может отличаться от информации в итоговом отчёте из-за незначительных различий в обработке данных.\n\n' +
    'Статистика обновляется в течение часа после отправки сообщений.',
  period: 'Выберите период',
  periodHint:
    'Если за предыдущий такой же период есть статистика, последней строкой в таблице отобразится динамика изменений',
  twoWeeks: 'За 2 недели',
  interactions: 'Статистика взаимодействий получателей',
  statistics: {
    interacted: 'Всего взаимодействий',
    interactedHint:
      'Количество взаимодействий получателей с сообщениями, отправленными по шаблону.\n\n' +
      'Динамика показывает насколько изменилось в процентном соотношении количество сообщений за выбранный период по сравнению с предыдущим таким же периодом.',
    sent: 'Отправлено сообщений',
    sentHint:
      'Количество отправленных сообщений по шаблону.\n\n' +
      'Динамика показывает насколько изменилось в процентном соотношении количество сообщений за выбранный период по сравнению с предыдущим таким же периодом',
    read: 'Прочитано сообщений',
    readHint:
      'Количество прочитанных получателями сообщений по шаблону.\n\n' +
      'Динамика показывает насколько изменилось в процентном соотношении количество сообщений за выбранный период по сравнению с предыдущим таким же периодом.',
    delivered: 'Доставлено сообщений',
    deliveredHint:
      'Количество доставленных сообщений по шаблону.\n\n' +
      'Некоторые сообщения могут быть не доставлены, например, если устройство получателя не обслуживается.\n\n' +
      'Динамика показывает насколько изменилось в процентном соотношении количество сообщений за выбранный период по сравнению с предыдущим таким же периодом.',
    shortLinkClicked: 'Переходов по кнопке-ссылке',
    shortLinkClickedHint:
      'Учитываются переходы только по тем кнопкам-ссылкам, у которых при создании шаблона была включена настройка «Отслеживать переходы по кнопкам-ссылкам».\n\n' +
      'Учитывается уникальный переход получателя по каждой кнопке-ссылке.\n\n' +
      'Статистика переходов собирается в течение 30 дней с момента отправки сообщения.',
    chatButtonClicked: 'Нажатий на чат-кнопку',
    chatButtonClickedHint: 'Учитывается уникальное нажатие получателя на каждую чат-кнопку.',
    replied: 'Процитировано сообщений',
    repliedHint: 'Учитывается каждый случай цитирования сообщения получателем',
  },
  chart: {
    sent: 'Отправленные сообщения',
    read: 'Прочитанные сообщения',
    delivered: 'Доставленные сообщения',
    interacted: 'Взаимодействия',
  },
  chartNoData: {
    title: 'Нет данных',
    subtitle: 'Пока что у нас нет статистики по этому шаблону за выбранный период',
  },
  noData: {
    title: 'Тут пока пусто',
    subtitle:
      'К сожалению, у вас пока нет зарегистрированных операторских шаблонов, для которых была бы доступна статистика',
    action: 'В шаблоны',
  },
};
